const { createQueuedCmd } = require('redux-serial-effects')
const pickBy_ = require('lodash/pickBy')
const forEach_ = require('lodash/forEach')
const isEmpty_ = require('lodash/isEmpty')
const maybe = require('folktale/maybe')
const convertValueToString = require('../helpers/convertValueToString')
const { SEND_AUTOMATION_EVENT_RESULT } = require('../records/actionTypes')

const TYPE = 'AUTOMATION_EVENT'
const SEND_AUTOMATION_EVENT = 'SEND_AUTOMATION_EVENT'

const {
  generateAutomationsFieldName,
  isFieldSupported
} = require('wix-code-automations-client')

const getFieldValue = require('../helpers/getFieldValue')

const getFieldValueAndTypeIfPossible = ({
  record,
  fieldData,
  fieldName,
  getSchema
}) => {
  let fieldValue
  let fieldType
  if (fieldData.type === 'reference') {
    const referenceSchema = getSchema(fieldData.referencedCollection)
    if (!isEmpty_(referenceSchema)) {
      fieldValue = getFieldValue(
        record[fieldName],
        referenceSchema.displayField
      )
      fieldType = referenceSchema.fields[referenceSchema.displayField].type
    } else return maybe.Nothing()
  } else {
    fieldValue = getFieldValue(record, fieldName)
    fieldType = fieldData.type
  }
  return maybe.Just({
    value: convertValueToString(fieldValue),
    type: fieldType
  })
}

const isFieldDeleted = fieldData => !!fieldData.isDeleted

const executor = ({
  Raven,
  getSchema,
  datasetId,
  datasetCollectionName,
  reportFormEventToAutomation
}) => {
  const sendAutomationEvent = async record => {
    try {
      const schema = getSchema(datasetCollectionName)
      const orderedFields = Object.getOwnPropertyNames(schema.fields)

      const supportedNotDeletedSchemaFields = pickBy_(
        schema.fields,
        (fieldData, fieldName) =>
          isFieldSupported(fieldData, fieldName) && !isFieldDeleted(fieldData)
      )
      const detailedEventPayload = {
        'form-id': {
          value: datasetId,
          keyName: ''
        }
      }
      forEach_(supportedNotDeletedSchemaFields, (fieldData, fieldName) => {
        const automationsFieldName = generateAutomationsFieldName(
          datasetId,
          fieldName
        )
        const index = orderedFields.indexOf(fieldName)
        const { displayName: keyName } = fieldData
        getFieldValueAndTypeIfPossible({
          record,
          fieldData,
          fieldName,
          getSchema
        }).matchWith({
          Just: ({ value }) => {
            const { value: fieldValue, type: valueType } = value
            detailedEventPayload[`field:${automationsFieldName}`] = {
              value: fieldValue,
              keyName,
              index,
              valueType
            }
          },
          Nothing: () => {}
        })
      })
      const eventUTCTime = getFieldValue(record, '_updatedDate')
      await reportFormEventToAutomation({
        eventUTCTime,
        detailedEventPayload
      })
    } catch (err) {
      if (err.message.includes('Network request failed')) {
        Raven.captureMessage(
          `automations integration - Network request failed on sendAutomationEvent`,
          {
            level: 'info'
          }
        )
      } else {
        Raven.captureException(err)
      }
    }
  }
  return {
    type: TYPE,
    execute: cmd => {
      return sendAutomationEvent(cmd.record)
    }
  }
}

const sendAutomationEventCmd = record => {
  return createQueuedCmd(
    TYPE,
    {
      type: SEND_AUTOMATION_EVENT,
      record
    },
    SEND_AUTOMATION_EVENT_RESULT
  )
}

module.exports.executor = executor
module.exports.sendAutomationEventCmd = sendAutomationEventCmd



// WEBPACK FOOTER //
// ./helpers/sendAutomationsEventExecutor.js